module.exports = __webpack_public_path__ + "img/14_sp.6aac26f2.gif";